module.exports = __webpack_public_path__ + "static/media/Group icon.46ae6947.png";